import React, { useState, useEffect, useContext } from 'react'
import { Form, Toast } from 'antd-mobile';
import { UserContext } from 'utils/getContext'
import dayjs from 'dayjs'
import { onUnitSubmitForm } from "api/api";
import { unitRegisterPage1 } from 'data/unitRegisterForm';
import { getFJJobWantedObj, getUserObj } from 'utils/getData'
import { GetFormType } from "./GetFormType";
import { FromSteps } from "./FromSteps";

/** 用人单位备案 */
export function UnitRegister() {
  const myContext = useContext(UserContext)
  const { userInfo } = myContext
  const { name, sex, idNum } = userInfo ? userInfo : {}
  const [form] = Form.useForm();
  const [postData, setPostData] = useState({})
  const [content, setContent] = useState({});
  const [stepNum, setStepNum] = useState(1)
  const [areaContent, setAreaContent] = useState([])
  const [formId, setFormId] = useState('');
  const [files, setFiles] = useState([]);

  const title = ['申报信息', '提交申请']
  const msgTitle = '用人单位备案'
  const pageData = [unitRegisterPage1]

  /** 对默认返回的参数进行处理后显示到页面上 */
  useEffect(() => {
    if (userInfo) {
      form.setFieldsValue({
        unitName: userInfo?.name || '',
        businessNum: userInfo?.idNum || '',
      });
    }
  }, [sex, name, form, userInfo, idNum]);

  /** 获取表单ID */
  useEffect(() => {
    const date = dayjs().format('YYYYMMDDHHmmss');
    setFormId(date + guid());
  }, []);
  /** 获取表单ID */
  function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      // eslint-disable-next-line no-bitwise
      const r = Math.random() * 16 | 0;
      // eslint-disable-next-line no-bitwise
      // eslint-disable-next-line no-mixed-operators
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  /** 初始化数据 */
  useEffect(() => {
    getFJJobWantedObj('', areaContent, setAreaContent)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** 更新提交表单接口参数数据 */
  function setFormInfo(name, value) {
    const newPostData = { ...postData }
    newPostData[name] = value
    setPostData(newPostData)
  }

  /** 提交表单 */
  async function handleSubmitFormClick(setLoading) {
    if (stepNum === title.length - 1) {
      setLoading(true)
      const errorTip = (msg) => {
        Toast.show({
          icon: 'fail',
          content: msg || '提交失败，请检查内容并重试',
        })
      }
      try {
        const formData = await form.validateFields();
        formData.file = files;
        const postInfo = new FormData();
        for (const key in formData) {
          if (key) {
            if (formData[key] && formData[key] !== undefined) {
              if (formData[key] instanceof Array) {
                formData[key].forEach((item, index) => {
                  postInfo.append(key, item)
                })
              } else {
                postInfo.append(key, formData[key])
              }
            }
          }
        }
        // 区分表单字段，后端需要
        postInfo.append('typeValue', '69');

        // 对应数据库表单名称  T_PSM_Company
        const res = await onUnitSubmitForm(postInfo);
        if (res?.data?.code === 200) {
          setStepNum(stepNum + 1)
        } else {
          errorTip()
        }
      } catch (e) {
        errorTip()
      } finally {
        setLoading(false)
      }
    }
  }

  /** 初始化表单渲染模板 */
  const getType = (arr, index) =>
    <GetFormType
      key={index}
      item={arr}
      setFormInfo={setFormInfo}
      content={content}
      setContent={setContent}
      getUserObj={getUserObj}
      //cityContent={cityContent}
      areaContent={areaContent}
      setAreaContent={setAreaContent}
      formId={formId}
      setFiles={setFiles}
      //getCityTreeObj={getCityTreeObj}
      getAreaObj={getFJJobWantedObj}
      msgTitle={msgTitle}
    />

  return (
    <FromSteps
      stepNum={stepNum} title={title}
      getType={getType} setStepNum={setStepNum}
      form={form} pageData={pageData}
      handleSubmitFormClick={handleSubmitFormClick}
    />
  )
}